class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this, false),
    );
    this.setHeaderCartIconAccessibility();

    const headerAccount = document.querySelector(".header__account");
    if (headerAccount) {
      headerAccount.addEventListener("click", () => {
        if (this.classList.contains("active")) {
          this.close();
        }
      });
    }

    const search = document.querySelector(".header__search");
    if (search) {
      search.addEventListener("click", () => {
        if (search.isOpen && this.classList.contains("active")) {
          this.close();
        }
      });
    }

    const localization = document.querySelectorAll(".header__localization");
    localization.forEach((localization) => {
      localization.addEventListener("click", () => {
        if (
          localization.querySelector("button[aria-expanded=true]") &&
          this.classList.contains("active")
        ) {
          this.close();
        }
      });
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      if (!this.classList.contains("active")) this.open(cartLink);
      else this.close();
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        if (!this.classList.contains("active")) this.open(cartLink);
        else this.close();
      }
    });
  }

  open(triggeredBy) {
    const search = document.querySelector(".header__search");
    if (search) {
      search.close();
    }
    const annBar = document.querySelector(".section-announcement");
    if (annBar) annBar.classList.add("section-announcement-overlay");

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden-drawer");
  }

  close() {
    const annBar = document.querySelector(".section-announcement");
    if (annBar) annBar.classList.remove("section-announcement-overlay");

    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden-drawer");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this, false),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

// Event delegation — survives cart drawer DOM re-renders on quantity/item changes.
// Capture phase + stopImmediatePropagation so we run before third-party app handlers
// (e.g. oneId) that would otherwise redirect to checkout before our validation.
// On success we re-dispatch the click with bypassCheckoutValidation=true so those
// third-party handlers run normally (e.g. oneId's /apps/pre-checkout flow).
var bypassCheckoutValidation = false;

document.addEventListener(
  "click",
  function (event) {
    const button = event.target.closest(
      "#CartDrawer-Checkout, .cart__checkout-button[name='checkout']",
    );
    if (!button) return;

    if (bypassCheckoutValidation) {
      bypassCheckoutValidation = false;
      return;
    }

    if (button.hasAttribute("disabled")) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var hasExistingItemError = Array.from(
      document.querySelectorAll(".cart-item__error-text"),
    ).some(function (el) {
      return el.textContent.trim() !== "";
    });
    if (hasExistingItemError) return;

    button.setAttribute("disabled", true);
    clearCheckoutError(button);
    clearAllItemErrors();

    fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        // Minimum spend: the website cart must total at least £50 to check out.
        var MIN_SPEND_CENTS = 5000;
        if (cart.total_price < MIN_SPEND_CENTS) {
          var remaining = ((MIN_SPEND_CENTS - cart.total_price) / 100).toFixed(
            2,
          );
          showCheckoutError(
            button,
            "Minimum order is £50. Please add £" +
              remaining +
              " more to check out.",
          );
          button.removeAttribute("disabled");
          return;
        }

        var requiredByGroup = {};
        var indicesByGroup = {};

        cart.items.forEach(function (item, idx) {
          var sgId = item.properties && item.properties["__seller_group_id"];
          if (!sgId) return;

          var key = String(sgId);
          var lotsizeOpt =
            item.options_with_values &&
            item.options_with_values.find(function (o) {
              return o.name.toLowerCase() === "lot size";
            });
          var lotsize = lotsizeOpt ? parseFloat(lotsizeOpt.value) || 1 : 1;
          var needed = lotsize * item.quantity;

          requiredByGroup[key] = (requiredByGroup[key] || 0) + needed;
          if (!indicesByGroup[key]) indicesByGroup[key] = [];
          indicesByGroup[key].push(idx + 1);
        });

        var ids = Object.keys(requiredByGroup);

        if (ids.length === 0) {
          return;
        }

        var url =
          "https://api-gateway.bulkit.uk/api/org-links/inventory/?ids=" +
          ids.join(",");

        return fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error("status " + res.status);
            return res.json();
          })
          .then(function (inventoryData) {
            var hasError = false;

            inventoryData.forEach(function (inv) {
              var key = String(inv.id);
              var needed = requiredByGroup[key];
              if (needed === undefined) return;

              var available = inv.inventory ? inv.inventory.quantity : 0;
              if (available < needed) {
                hasError = true;
                var msg =
                  "Only " +
                  available +
                  " units available (" +
                  needed +
                  " added).";
                (indicesByGroup[key] || []).forEach(function (lineIndex) {
                  showItemError(lineIndex, msg);
                });
              }
            });

            if (hasError) {
              button.removeAttribute("disabled");
            } else {
              submitCheckout(button);
            }
          });
      })
      .catch(function (err) {
        console.error("Inventory check failed:", err);
        showCheckoutError(
          button,
          "Unable to verify inventory. Please try again.",
        );
        button.removeAttribute("disabled");
      });
  },
  true,
);

function showItemError(lineIndex, message) {
  var errEl =
    document.getElementById("CartDrawer-LineItemError-" + lineIndex) ||
    document.getElementById("Line-item-error-" + lineIndex);
  if (!errEl) return;
  var textEl = errEl.querySelector(".cart-item__error-text");
  if (textEl) textEl.textContent = message;

  // Open the vendor accordion that contains this item (if collapsed)
  var accordion = errEl.closest("details.cart-drawer__vendor-accordion");
  if (accordion) accordion.setAttribute("open", "");
}

function clearAllItemErrors() {
  document.querySelectorAll(".cart-item__error-text").forEach(function (el) {
    el.textContent = "";
  });
}

function showCheckoutError(button, message) {
  var errEl = button.parentElement.querySelector(".checkout-inventory-error");
  if (!errEl) {
    errEl = document.createElement("p");
    errEl.className = "checkout-inventory-error";
    errEl.style.cssText =
      "margin:0 0 10px;font-size:1.3rem;color:#c40000;text-align:center;";
    button.parentElement.insertBefore(errEl, button);
  }
  errEl.textContent = message;
}

function clearCheckoutError(button) {
  var errEl =
    button.parentElement &&
    button.parentElement.querySelector(".checkout-inventory-error");
  if (errEl) errEl.remove();
}

function submitCheckout(button) {
  // Re-dispatch the click so third-party handlers (oneId) get to run.
  // Our capture-phase listener sees the bypass flag and lets it through.
  button.removeAttribute("disabled");
  bypassCheckoutValidation = true;
  button.click();
}
